/**
 * Models the result of initializing a multisig wallet which results in the
 * multisig wallet's address xor another multisig hex to share with
 * participants to create the wallet.
 */
export default class MoneroMultisigInitResult {
    constructor(result) {
        Object.assign(this, result);
    }
    toJson() {
        return Object.assign({}, this);
    }
    getAddress() {
        return this.address;
    }
    setAddress(address) {
        this.address = address;
        return this;
    }
    getMultisigHex() {
        return this.multisigHex;
    }
    setMultisigHex(multisigHex) {
        this.multisigHex = multisigHex;
        return this;
    }
}
